import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import  PageHeader  from './PageHeader';
import  ForgotPwForm   from './ForgotPwForm';
// import {FooterSection }  from './FooterSection';
import Footer from "../components/common/Footer";
import { sendResetPwMail } from '../actions/auth'; 
import  getAppConfigParm  from '../config/AppConfig';
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';

// import { GoogleAdInit } from './advertisement/GoogleAdInit';


// This LoginPage is the top level component. It renders the PageHeader and Login Form.
// This component passes its onSubmit method down to the LoginForm child component.
// It delegates the data entry and form data validation to the form itself. Once the
// form has validated the data, it will pass the form data up to this component by calling
// the onSubmit method passed down as a function prop. That form data will used to dispatch
// the startLogin action. The startLogin action will log in the user, and update redux store 
// with user firstname, email, token, and isAuthenticated flag. When action successfully completes, 
// the user will be routed to the '/dashboard'. If login fails, the auth.error property 
// will be updated on the redux store and component will re-render with error message on top of form.
export class ForgotPwPage extends React.Component { 

    // Dispatch action that sends email to user to reset password. If email is not
    // registered, the auth.error property will be set on the redux store. If action is
    // is successful, it will route user to home page.
    onSubmit = (email = '') => {
        this.props.sendResetPwMail(email);
    };
     
    // Render login page and pass onSubmit function above, as function prop, to LoginForm. This function 
    // prop will be called when user enters email and password and clicks onSumbit on form itself.
    render() {

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");

        return (
            <div> 
               <Helmet>
                 <title>Forgot Password</title>
                 <meta name="description" content="Forgot password for Pitch In Club" />
               </Helmet>
               <PageHeader />
               <VisibilityWrapper show={showAd} contentType="advertisement">
                    <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                        {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                        {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                        {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    </div>
               </VisibilityWrapper>  
               <div className="app-container">    
                   <div className="app-content-container"> 
                        <div>
                              <ForgotPwForm 
                               onSubmit={this.onSubmit}
                              />  
                           </div>
                           <div className="rc-xlarge-mobile-gutter">&nbsp; </div> 
                       </div>
                       
               </div>
               <VisibilityWrapper show={showAd} contentType="advertisement" >
                <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                </div> 
               </VisibilityWrapper>
               <Footer />
            </div>
        );
    };
};


// When using mapDispatchToProps you invoke function in your component as follows:
// this.props.startSignup(signupData) and not like this: this.props.dispatch(startSignup(signupData))
const mapDispatchToProps = (dispatch) => ({
    sendResetPwMail: (email) => dispatch(sendResetPwMail(email)),
})

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPwPage);





// WEBPACK FOOTER //
// ./src/components/ForgotPwPage.js